import React, { useState, useEffect } from 'react';
import {
	Drawer,
	Box,
	Typography,
	Button,
	Divider,
	IconButton,
	FormControlLabel,
	Switch,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';

import PaymentMethodList from './components/PaymentMethodList';

import useStyles from './styles';

import useBooking from '../../../../context/useBooking';
import useHasBookingInRange from '../../../../context/useHasBookingInRange';
import { useIsDesktop, useTranslations } from 'components/utilities';
import getErrorMessage from 'helpers/getErrorMessage';

const CarDetailsPaymentMethods = () => {
	const classes = useStyles();

	const { t } = useTranslations();

	const {
		isPaymentMethodsVisible,
		togglePaymentMethodsVisible,
		paymentMethod,
		handleBook,
		isError,
		error,
	} = useBooking();

	const {
		hasBookingInRange,
		isLoaded: isHasBookingInRangeLoaded,
	} = useHasBookingInRange();

	const [cancelPreviousBooking, setCancelPreviousBooking] = useState(false);

	const toggleCancelPreviousBooking = () => {
		setCancelPreviousBooking(!cancelPreviousBooking);
	};

	const isDesktop = useIsDesktop();

	useEffect(() => {
		if (!isHasBookingInRangeLoaded) {
			return;
		}

		if (cancelPreviousBooking && !hasBookingInRange) {
			setCancelPreviousBooking(false);
		}
		// eslint-disable-next-line
	}, [hasBookingInRange, isHasBookingInRangeLoaded]);

	return (
		<Drawer
			anchor="bottom"
			open={isPaymentMethodsVisible}
			onClose={togglePaymentMethodsVisible}
		>
			<Box p={3} position="relative">
				<Typography variant="h5" align="center">
					{t('booking.payment_options')}
				</Typography>
				<IconButton
					onClick={togglePaymentMethodsVisible}
					className={classes.closeBtn}
				>
					<CloseIcon fontSize={isDesktop ? 'large' : 'default'} />
				</IconButton>
			</Box>

			<Divider />

			<PaymentMethodList />

			<Divider />

			<Box py={isDesktop ? 4 : 2} px={isDesktop ? 12 : 2}>
				{hasBookingInRange && (
					<Box mb={3}>
						<Alert severity="warning">
							{t('booking.have_booking_in_period')}
						</Alert>
						<Box mt={3} display="flex" justifyContent="center">
							<FormControlLabel
								control={
									<Switch
										color="primary"
										checked={cancelPreviousBooking}
										onChange={toggleCancelPreviousBooking}
									/>
								}
								label={t('booking.cancelPreviousBooking')}
							/>
						</Box>
					</Box>
				)}
				{isError && (
					<Box mb={3}>
						<Alert severity="error">{getErrorMessage(error)}</Alert>
					</Box>
				)}
				<Button
					variant="contained"
					color="primary"
					size={isDesktop ? 'large' : 'medium'}
					fullWidth
					disabled={!paymentMethod}
					onClick={() => handleBook(cancelPreviousBooking)}
				>
					{t('car.book')}
				</Button>
			</Box>
		</Drawer>
	);
};

export default CarDetailsPaymentMethods;
